export const NEW_STATUS_TEXT = 'Awaiting payment';
export const PENDING_STATUS_TEXT = 'Processing';
export const PAID_STATUS_TEXT = 'Completed';
export const EXPIRED_STATUS_TEXT = 'Expired';
export const ERROR_STATUS_TEXT = 'Cannot check';
